import RulesDetails from './components/rulesDetails/RulesDetails';

type Props = {
    isAdmin?: boolean,
    companyId?: string
}
const RulesTab = ({ isAdmin, companyId }:Props) => {

    return (<RulesDetails isAdmin={isAdmin} companyId={companyId}></RulesDetails>);
}

export default RulesTab;
